import React from 'react';
import facenail from '../assets/facenail.webp';
import './Booking.css';

const Booking = () => {
  return (
    <>
<center> 
  <div className="container d-flex bookingcontainer" >
      <div className="d-flex justify-content-center ">
        <div className="booking col-sm-7 text-center" style={{height :'300px'}}>
          <form className="d-flex flex-column align-items-center justify-content-center pt-5 p-1 bookingform" >
            <div className="mb-3 w-50 pt-4">
              <select
                id="service"
                className="form-select bookingform"
                style={{ fontSize: '15px'  }}
                required
              >
                <option value="" disabled selected style={{ fontSize: '15px' }}>
                  Pick your service
                </option>
                <option value="massage" style={{ fontSize: '15px' }}>
                  Nail Service
                </option>
                <option value="facial" style={{ fontSize: '15px' }}>
                  Hair Service
                </option>
                <option value="manicure" style={{ fontSize: '15px' }}>
                  Lash Service
                </option>
                <option value="pedicure" style={{ fontSize: '15px' }}>
                  Waxing Service
                </option>
                <option value="skincare" style={{ fontSize: '15px' }}>
                  Skincare Treatments
                </option>
              </select>
            </div>
            <div className="mb-3 w-50">
              <input
                type="time"
                className="form-control bookingform"
                placeholder="Enter Time"
                name="time"
              />
            </div>
          </form>
          <div className="d-flex justify-content-center bookingbtn" >
            <button
              className=" btn-sm bookbtn text-center  rounded-pill p-1 w-40"style={{color: 'white',fontSize: '13px',fontStyle: 'italic',fontFamily: "'TAN TWINKLE', cursive",backgroundColor:'#e8c6c6'}}>
              Book Your Appointment
            </button>
          </div>
        </div>
        <div className="col-sm-7 imagebooking">
          <img
            src={facenail}
            alt="Nail Services"
            style={{ width: '100%', height: '300px' }}
          />
        </div>
      </div>
    </div>
</center>

  <div className="container mt-1">
    <h5 className="text-center mb-1" style={{ fontFamily: "'Arial', sans-serif", color: '#b37777', fontStyle: 'italic' }}>
      Need help? Here are answers to common questions:
    </h5>
    </div>
    <div className='servicecontainer'>
    <div className="accordion accordion-sm" id="faqAccordion"  style={{ maxWidth: '600px', margin: 'auto' }}>
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingOne">
          <button
            className="accordion-button collapsed p-2 fs-6"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="false"
            aria-controls="collapseOne"
          >
            What if I need to cancel my appointment?
          </button>
        </h2>
        <div
          id="collapseOne"
          className="accordion-collapse collapse"
          aria-labelledby="headingOne"
          data-bs-parent="#faqAccordion"
        >
          <div className="accordion-body p-2 fs-7">
            We kindly ask for 24 hours' notice.
          </div>
        </div>
      </div>
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingTwo">
          <button
            className="accordion-button collapsed p-2 fs-6"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
          >
            Can I walk in without an appointment?
          </button>
        </h2>
        <div
          id="collapseTwo"
          className="accordion-collapse collapse"
          aria-labelledby="headingTwo"
          data-bs-parent="#faqAccordion"
        >
          <div className="accordion-body p-2 fs-7">
            Walk-ins are welcome, but availability may vary.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className='p-2'></div>

    
    </>
  )
}
export default Booking;